import React from "react";
import "./RefundPolicy.css";

const RefundPolicy = () => {
  return (
    <div className="refund-policy-container">
      <h2 className="title">Return &amp; Refund Policy</h2>

      {/* Introduction */}
      <section className="section">
        <p>
          Simplicity, transparency and security are the hallmarks of your online shopping experience at <strong>Kraafty.com</strong>. We go the distance to ensure that every transaction on our website is seamless.
        </p>
        <p>
          We take great care in delivering our products and adhere to the highest quality standards. As a policy, we do not entertain returns on products delivered in perfect, undamaged condition. Please read our Return Policy below for your understanding.
        </p>
      </section>

      {/* Eligibility */}
      <section className="section">
        <h3 className="section-title">Eligibility for Return</h3>
        <ul>
          <li>A wrong product has been dispatched and does not match the item selected during order confirmation.</li>
          <li>A quality or manufacturing defect is identified on the received product.</li>
          <li>The product is received in a damaged condition. <em>Please do not accept any package if it is tampered or damaged upon delivery.</em></li>
        </ul>
      </section>

      {/* Return Process */}
      <section className="section">
        <h3 className="section-title">Return Process</h3>
        <ol>
          <li>Raise a return request within 48&nbsp;hrs of delivery by calling our Customer Service at <a href="tel:+918005629558">+91&nbsp;8005629558</a> (Mon-Sat&nbsp;10&nbsp;AM-7&nbsp;PM&nbsp;IST) or email <a href="mailto:support@kraafty.com">support@kraafty.com</a>. You can also submit your request from <strong>My Account → Submit a Support Request</strong>.</li>
          <li>Send a clear picture/video of the product depicting the issue along with order details to the above email/WhatsApp for faster processing. Our Quality Assurance team will evaluate eligibility.</li>
          <li>We will update you on the return request status within 2-3 days. Upon approval, a reverse pickup will be arranged (2-3 working days for pickup, 10-30 days to reach our warehouse).</li>
          <li>Once the merchandise reaches our warehouse, the refund process will initiate within 7 days.</li>
        </ol>
      </section>

      {/* Points to Remember */}
      <section className="section">
        <h3 className="section-title">Points to Remember</h3>
        <ul>
          <li>Product must be returned with the original packaging, including tags, barcodes, accessories, manuals, warranty cards, shipping label and invoice.</li>
          <li>Product should be unused and in its original condition.</li>
          <li>Products can be returned for store credit or refund; both are processed within 7 days of receiving the merchandise.</li>
          <li>Kraafty.com reserves the right to do a thorough quality check before issuing any refund. Each request is handled on a case-by-case basis.</li>
          <li>Products bought online cannot be exchanged or returned in physical stores.</li>
        </ul>
        <p className="note">
          <em>Disclaimer: All policies are subject to change without prior notice. In case of any conflict, the Terms &amp; Conditions policy will prevail.</em>
        </p>
      </section>

      {/* Refund Policy */}
      <section className="section">
        <h3 className="section-title">Refund Policy</h3>
        <p>All refunds are processed within 7 days of the merchandise reaching our warehouse. Refunds will be issued as Store Credits or via the original payment method.</p>
        <p><strong>Store Credits</strong> have no expiry date or usage limitations and are usually issued within 24-48 hours.</p>
        <p>Refunds via the original payment method follow the same transaction channel. Online refunds are processed within 7 working days; banks may take ~5 days, and credit cards will reflect in the next billing cycle.</p>
      </section>

      {/* Cancellation Policy */}
      <section className="section">
        <h3 className="section-title">Cancellation Policy</h3>
        <p>Cancellation requests will be accepted within 24&nbsp;hrs of placing the order for a full refund.</p>
        <p>If the product is already in transit, an in-transit cancellation fee of 10% of the order value will be charged to cover shipping costs.</p>
        <p>To cancel, contact Customer Service at <a href="tel:+918005629558">+91&nbsp;8005629558</a> (Mon-Sat&nbsp;10&nbsp;AM-7&nbsp;PM&nbsp;IST) or email <a href="mailto:support@kraafty.com">support@kraafty.com</a>. Refunds will be made via the same payment mode.</p>
      </section>

      {/* Need Help */}
      <section className="section">
        <h3 className="section-title">Need Help?</h3>
        <p>For any assistance contact our Customer Service at <a href="tel:+918005629558">+91&nbsp;8005629558</a> (Mon-Sat&nbsp;10&nbsp;AM-7&nbsp;PM&nbsp;IST) or email <a href="mailto:support@kraafty.com">support@kraafty.com</a>. You can also submit a return request via <strong>My Account → Submit a Support Request</strong>.</p>
      </section>
    </div>
  );
};

export default RefundPolicy;
